
import { useState, useMemo, useEffect, useCallback, useContext } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom';
import { sortRows, filterRows, paginateRows } from '../helpers'
import Pagination from '../Pagination'
import CompanyLogo from '../CompanyLogo';
import SortIcon from 'mdi-react/SortIcon'
import SortAscendingIcon from 'mdi-react/SortAscendingIcon'
import SortDescendingIcon from 'mdi-react/SortDescendingIcon'
import '../TableView.css'
import { routeNames } from '../../routeSegments';
import RandomLogo from '../RandomLogo';
import OverflowToolTip from '../shared/OverflowToolTip';
import { rowsPerPageData, maAcquirerListApi, getPEGlobalSearchCompaniesApi } from '../../Config/config'
import { TableDataContext } from '../../Contexts/TableDataContext'
import axios from "axios";
import CustomNavigation from '../../Utils/CustomNavigation';
import NoDataPlaceholder from '../shared/NoDataPlaceholder';
import Loader from '../Loader';
import { UserContext } from '../../Contexts/UserContext';
import AddNotePopover from '../shared/AddNotePopover';
import Constants from '../../Constants';
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import moment from "moment";
import { useRef } from 'react';
import DeleteItemsFromGroup from '../shared/DeleteItemsFromGroup';
import { toast } from 'react-toastify';
import TwolineOverflowToolTip from '../shared/TwolineOverflowToolTip';
import NewLogo from '../NewLogo';


/**
 * The `Table` component is a JavaScript function that renders a table based on the provided columns,
 * menu, month, order, and orderBy parameters.
 * @returns The `Table` component is being returned.
 */
const Table = ({ columns, menu, month, order, orderBy,sub_type_master_id }) => {

  const { rows, setRows, data, setData, isLoad, setIsLoad, isDataLoad, setIsDataLoad, totalNoOfCompanies, setTotalNoOfCompanies, currency, setTableAcquirerId, currentPage, setCurrentPage,setCurrentFilter, setAllDealIds, globalSearchResult, setGlobalSearchResult} = useContext(TableDataContext);
  const { monthPickerValue, setMonthPickerValue, isMonthPickerChanged, setIsMonthPickerChanged, isTagClosed, setIsTagClosed, refineSearchFilters,groupId, accessControl} = useContext(PeFilterContext);
  const [activePage, setActivePage] = useState(currentPage)
  const [filters, setFilters] = useState({})
  const [sort, setSort] = useState({ order: order, orderBy: orderBy })
  // const [sort, setSort] = useState({ order: 'asc', orderBy: 'acquirer_name' })
  const [showId, setShowId] = useState(null);
  const [showNote, setShowNote] = useState(false)
  const { getToken, logout } = useContext(UserContext);
  const abortRef = useRef(null)
  var location = useLocation();
  const locState = location.state && location.state?.legacyFilterData || location.state?.gsResults
  const[reload, setReload] = useState(false)

  /**
   * The function `findActivePage` sets the current page, renders a table with specified parameters,
   * and sets a flag indicating that the page is loading.
   * @param page - The "page" parameter represents the current page number.
   */
  const findActivePage = (page) => {
    setCurrentPage(page)
    tableRender(page, monthPickerValue, sort.orderBy, sort.order,groupId)
    setIsLoad(true)
  }

  console.log('refineSearchFiltersma', refineSearchFilters[location.pathname]);
  const isFromGlobalSearch = ()=> refineSearchFilters[location.pathname]?.globalSearch?.length > 0 ? true : false

  // Add a ref to track if we've already fetched global search results
  const hasFetchedGlobalSearch = useRef(false);

  const getGlobalSearchIds = async () => {
    try {
      const targetCollection = 'pe_acquirer';
      
      // First check if we already have valid results in globalSearchResult
      if (globalSearchResult?.[targetCollection]?.length > 0) {
        console.log(`AcquirerTable: Using existing valid IDs from globalSearchResult:`, globalSearchResult[targetCollection]);
        const acquirerIds = (globalSearchResult[targetCollection] || []).map(id => parseInt(id));
        return acquirerIds.length > 0 ? acquirerIds : [0];
      }

      // If we've already tried to fetch in this session, don't fetch again
      if (hasFetchedGlobalSearch.current) {
        console.log('AcquirerTable: Already fetched global search in this session, using fallback');
        return [0];
      }

      // Get search parameters from navigation state or session storage
      let searchQuery = location.state?.globalSearchQuery;
      let searchType = location.state?.globalSearchType;
      let resultCount = location.state?.globalSearchResultCount;
      let isFromGlobalSearchFlag = location.state?.isFromGlobalSearch;
      
      // If we don't have search parameters from navigation state, try session storage
      if (!searchQuery) {
        const storedSearchData = sessionStorage.getItem('globalSearchContext');
        if (storedSearchData) {
          try {
            const parsed = JSON.parse(storedSearchData);
            searchQuery = searchQuery || parsed.searchQuery;
            searchType = searchType !== undefined ? searchType : parsed.searchType;
            resultCount = resultCount || parsed.resultCount;
            isFromGlobalSearchFlag = isFromGlobalSearchFlag || parsed.isFromGlobalSearch;
            console.log('AcquirerTable: Retrieved search parameters from session storage:', parsed);
          } catch (e) {
            console.error('AcquirerTable: Error parsing stored search data:', e);
          }
        }
      }
      
      // Only proceed with fresh search if we have valid search parameters
      if (searchQuery && searchType !== undefined) {
        // Mark that we're attempting to fetch
        hasFetchedGlobalSearch.current = true;
        
        const searchResultCount = resultCount || 1000;
        
        console.log(`AcquirerTable: Performing fresh search for collection: ${targetCollection}`);
        
        try {
          // Import the search function dynamically
          const { getSearchResultIdsAll } = await import('../useGlobalSearch');
          
          // Perform a fresh search for this specific collection
          const freshSearchResults = await getSearchResultIdsAll(
            searchQuery,
            searchResultCount,
            searchType,
            [targetCollection]
          );
          
          console.log(`AcquirerTable: Fresh search results for ${targetCollection}:`, freshSearchResults);
          
          // Update the global search result with fresh data
          if (freshSearchResults && freshSearchResults[targetCollection]?.length > 0) {
            setGlobalSearchResult(freshSearchResults);
            const acquirerIds = (freshSearchResults[targetCollection] || []).map(id => parseInt(id));
            return acquirerIds.length > 0 ? acquirerIds : [0];
          }
        } catch (error) {
          console.error('AcquirerTable: Error performing fresh search:', error);
        }
      }
      
      console.log('AcquirerTable: No valid search parameters or results found, using default [0]');
      return [0]; // Default fallback
    } catch (error) {
      console.error('AcquirerTable: Error fetching global search IDs:', error);
      return [0];
    }
  };

  /* The above code is a JavaScript function that uses the `useCallback` hook. It is a table rendering
  function that makes an API call to fetch data based on the provided parameters (page, month,
  column, order). */
  const tableRender = useCallback((page, month, column, order) => {
    console.log(month, 'm usecallback month'); 

    // Get enhanced global search IDs if needed
    const getAcquirerIds = async () => {
      if (isFromGlobalSearch()) {
        const ids = await getGlobalSearchIds();
        console.log('Enhanced acquirer IDs from global search:', ids);
        return ids;
      } else {
        return refineSearchFilters[location.pathname]?.globalSearch?.at(0)?.value || [];
      }
    };

    // Start the async operation but don't await it in the main function
    getAcquirerIds().then(acquirerIds => {
      setIsTagClosed(0)
      setIsMonthPickerChanged(0)
      axios(`${maAcquirerListApi}`, {
        method: "POST",
        signal: abortRef.current.signal,
        data: locState ? locState : {
          date_range: {
                  from_date: moment(month[0]).format("YYYY-MM-DD"),
                  to_date: moment(month[1]).format("YYYY-MM-DD"),
                },
          "order_by": {
            "column": column,
            "direction": order
          },
          from : isFromGlobalSearch() || location.state?.isFromGlobalSearch || 
                  (globalSearchResult && Object.keys(globalSearchResult).length > 0) ? 'gs' : '',
          "page": page,
          acquirer_group: refineSearchFilters[location.pathname]?.acquirer_group?.map(opt => opt.name),
          "acquirer_city": refineSearchFilters[location.pathname]?.acquirerCity?.map(city => city.id),
          "acquirer_ids":isFromGlobalSearch() ? acquirerIds : refineSearchFilters[location.pathname]?.acquirers?.map(acq => acq.id) ,
          "acquirer_company_type": refineSearchFilters[location.pathname]?.acquirerType?.map(type => type.id),
          "acquirer_country": refineSearchFilters[location.pathname]?.acquirerCountries?.map(city => city.id),
          "company_group": refineSearchFilters[location.pathname]?.group?.map(group => group.name),
          "acquirer_region": refineSearchFilters[location.pathname]?.acquirerRegion?.map(city => city.id),
          "acquirer_state": refineSearchFilters[location.pathname]?.acquirerState?.map(city => city.id),
          "deal_range": refineSearchFilters[location.pathname]?.dealRange?.at(0) && {
            "from": refineSearchFilters[location.pathname]?.dealRange[0].name,
            "to": refineSearchFilters[location.pathname]?.dealRange[1].name
          },
          "deal_type": refineSearchFilters[location.pathname]?.dealType?.map(type => type.id),
          "ladvisor_ids":refineSearchFilters[location.pathname]?.ladvisors?.map(acq => acq.id)  ,
          // "operator" : refineSearchFilters[location.pathname]?.operator,
          "tadvisor_ids":refineSearchFilters[location.pathname]?.tadvisors?.map(acq => acq.id)  ,
          "target_city": refineSearchFilters[location.pathname]?.city?.length > 0 ? refineSearchFilters[location.pathname]?.city?.map(
                  (city) => city.id
                ) : accessControl?.ma_cities?.id,
          "target_company_type": refineSearchFilters[location.pathname]?.companyType?.map(type => type.id),
          "target_country": refineSearchFilters[location.pathname]?.countries?.length > 0 ? refineSearchFilters[location.pathname]?.countries?.map(country => country.id) : accessControl?.ma_countries?.id,
          "target_industry": refineSearchFilters[location.pathname]?.industry?.length > 0 ? refineSearchFilters[location.pathname]?.industry?.map(
                  (value) => value.id) : accessControl?.maindustries?.id,
          "acquirer_industry": refineSearchFilters[location.pathname]?.acquirer_industry?.length > 0 ? refineSearchFilters[location.pathname]?.acquirer_industry?.map(
            (value) => value.id) : accessControl?.maindustries?.id,
          "target_sector" : refineSearchFilters[location.pathname]?.sector?.map(value => value.name),
          "target_region": refineSearchFilters[location.pathname]?.region?.length > 0 ? refineSearchFilters[location.pathname]?.region?.map(
                  (region) => region.id
                ) : accessControl?.ma_regions?.id,
          "target_state": refineSearchFilters[location.pathname]?.state?.length > 0 ? refineSearchFilters[location.pathname]?.state?.map(
                  (state) => state.id
                ) : accessControl?.ma_states?.id,
          "valuation": refineSearchFilters[location.pathname]?.valuations?.map(valuation => valuation.value),
          group:{  
            group_id: groupId?.myList?.map(id => id.group_id)?.toString() ?? null,
            sub_type_master_id: groupId?.myList?.length >0 ? sub_type_master_id :null   
          }
        },
      headers: {
        "Content-Type": "application/json",
        "Authorization": getToken()
      },

    })
      .then((response) => {
        if (response?.data?.message == "Success") {
          // console.log(response,'cfs table response');      
          setCurrentFilter(response.config.data) 
          setTotalNoOfCompanies(response?.data?.num_acquirers)
          setIsLoad(false)
          setIsDataLoad(false)
          // setIsMonthPickerChanged(0)
          setRows([])
          setRows(response?.data?.companies)
          
          setData(response?.data)
          setTableAcquirerId(response?.data?.all_acquirer_ids)
          setAllDealIds(response?.data?.all_deal_ids)
          console.log(response?.data, 'cfs table response');
        }
      })
      .catch((error) => {
        if (error?.response?.status == Constants.sessionTerminatedStatus 
            || error?.response?.status == Constants.InvalidTokenStatus
          ){
          logout();
        }
        console.log("API not working", error);
      });
    }); // Close the getAcquirerIds().then()
  }, [refineSearchFilters, globalSearchResult]);


  useEffect(() => {
    const abortController = new AbortController()
    abortRef.current = abortController;
    setIsLoad(true)
    setIsDataLoad(true)
    setCurrentPage(currentPage);
    tableRender(currentPage, monthPickerValue, sort.orderBy, sort.order,groupId )
    return () => {
      abortController.abort();
    }
  }, [tableRender, monthPickerValue,groupId ,reload]);

  /**
   * The addNote function toggles the visibility of a note and sets the id of the note to be shown.
   * @param id - The `id` parameter is the identifier of the note that needs to be added.
   */
  const addNote = (id) => {
    setShowNote(!showNote)
    setShowId(id)
  }

  const rowsPerPage = rowsPerPageData

  const filteredRows = useMemo(() => filterRows(rows, filters), [rows, filters])
  // const sortedRows = useMemo(() => sortRows(filteredRows, sort), [filteredRows, sort])
  // const calculatedRows = paginateRows(sortedRows, currentPage, rowsPerPage)
  // console.log(calculatedRows, "cfs calculated")

  /**
   * The function `handleSort` is used to handle sorting of data in a table based on a given accessor
   * and order.
   * @param accessor - The `accessor` parameter is a value that represents the property or key of the
   * object that you want to sort by. It is used to identify the specific property or key that you want
   * to sort the data by.
   * @param order - The "order" parameter is used to specify the sorting order. It can have two
   * possible values: 'asc' for ascending order and 'desc' for descending order.
   */
const handleSort = (accessor) => {
  setCurrentPage(currentPage); // Assuming currentPage is defined elsewhere
  setRows([]);
  setIsLoad(true);
  setIsDataLoad(true);

  const isNumericColumn = ["acquisitions", "total_acquistions"].includes(accessor);

  setSort((prevSort) => {
    const isSameColumn = prevSort.orderBy === accessor;
    const newOrder = isSameColumn
      ? prevSort.order === 'desc' ? 'asc' : 'desc'
      : isNumericColumn ? 'desc' : 'asc'; // Default to 'desc' for numeric columns, 'asc' for others

    // Call tableRender with the new order
    tableRender(currentPage, monthPickerValue, accessor, newOrder, groupId);

    return {
      order: newOrder,
      orderBy: accessor,
    };
  });
};
  const count = filteredRows.length
  // const totalPages = Math.ceil(count / rowsPerPage)

  console.log(count, filteredRows, 'count');

  var location = useLocation();


 /**
  * The function `addCommasToNumber` takes a number as input and returns a string representation of the
  * number with commas added for thousands separators.
  * @param number - The `number` parameter is the number to which commas need to be added.
  * @returns The function `addCommasToNumber` returns a string with commas added to the number.
  */
  const addCommasToNumber = (number) => {
    return number?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  
    useEffect(()=>{
    console.log(location?.state?.isFromGlobalSearch, 'isFromGlobalSearch');

  },[location?.state?.isFromGlobalSearch])
  return (
    <>
      <div className="md:col-span-4 col-span-5">
        <div className="lg:col-span-4">
          <div className="scrollbar ">
             <div className={"overflow-x-auto scrollbar rounded-b-[6px] "+(rows.length > 5 ? '':'pr-2')}>
              <table className="listPage table w-full p-1 bg-grey-50 divide-y" width="50%">
                <thead className="bg-[#EBEBEB] text-[11pt] leading-[16pt] lg:text-[13px] lg:leading-[15px] font-semibold text-[#666666]  text-left">
                  <tr>
                    {columns.map((column, i) => {
                      const sortIcon = () => {
                        if (column.accessor === sort.orderBy) {
                          if (sort.order === 'asc') {
                            return <SortDescendingIcon className="pl-2 block h-[15px]" />
                          }
                          return <SortAscendingIcon className="pl-2 block h-[15px]" />
                        } else {
                          return <SortIcon className="pl-2 block h-[15px] " />
                        }
                      }
                      return (

                        <th className={i === 0 ? "md:pl-5 md:pr-5 pl-5 pr-[9rem]" : "px-5 " + " py-2 font-sans_book_body"} key={i}>
                          <span className="flex whitespace-nowrap"> 
                            <OverflowToolTip className="hover:text-[#000000] cursor-auto" component={
                              <a className="hover:text-[#000000] cursor-auto">
                                {column.accessor === "add" && groupId?.myList?.length > 0 ? "Delete" :
                                  column.accessor === "add" ? (
                                    <div className="flex flex-col text-center">
                                      <span>Create</span>
                                      <span>your list</span>
                                    </div>
                                  ) : column.accessor === "total_acquistions" ? (
                                    <div className="flex flex-col text-center">
                                      <span>Total Acquisitions</span>
                                      <span>(US$ M)</span>
                                    </div>
                                  ) : column.label ? column.label : "--"}
                              </a>
                            } />
                            {column.accessor !== "add" && (
                              <button onClick={() => handleSort(column.accessor, sort.order)}>
                                {sortIcon()}
                              </button>
                            )}
                          </span>
                        </th>
                      )
                    })}
                  </tr>
                </thead>
                {!isLoad ?
                  count > 0 ?
                    <tbody className="text-[11pt] leading-[16pt] lg:text-[14px] lg:leading-[16px] font-sans_book_body text-[#333333] text-left">
                      {rows.length > 0 ?
                        rows?.map((row, i) => {
                          return (
                            <tr key={i} className=" group hover:border-l-4 hover:border-l-[#BC8B20] border-l-4 border-l-[#FFFFFF]   border-b bg-white text" >
                            <td className="w-[21%] 2xl:w-[10%] leading-relaxed font-medium px-5 py-3 font-sans_book_body card-animate">
                              <div className="flex items-center">
                                <NewLogo id={row.acquirer_id} name={row.acquirer_name} menu={"ma_acquirer"} />

                                <OverflowToolTip
                                  className="w-[10rem] lg:max-w-[18rem]"
                                  component={
                                    <>
                                      {row?.acquirer_name === "PE Firm(s)" ? (
                                        <span className="flex text-start lg:inline leading-[1.1rem] lg:whitespace-normal break-words font-medium">
                                          {row.acquirer_name}
                                        </span>
                                      ) : (
                                        <NavLink
                                          className="flex text-start lg:inline leading-[1.1rem] lg:whitespace-normal break-words hover:text-[#BC8B20] font-medium"
                                          state={{ prevPath: location.pathname }}
                                          to={routeNames.maAcquiresById(row.acquirer_id)}
                                        >
                                          {row?.acquirer_name ? row.acquirer_name : "--"}
                                        </NavLink>
                                      )}
                                    </>
                                  }
                                />
                              </div>
                            </td>
                              <td className="w-[5%] py-3 font-sans_book_body text-right px-5 pr-[2.8rem] lg:pr-[2.7rem] 2xl:pr-[3.7rem] ">
                                {row.acquisitions ? addCommasToNumber(row.acquisitions) : "--"}
                              </td>
                              <td className="w-[18%] py-3 px-5 font-medium font-sans_book_body whitespace-normal break-words">
                                <TwolineOverflowToolTip
                                  className="w-[10rem] line-clamp-2 leading-relaxed"
                                  component={
                                    row?.top_acquistion?.length > 0 ? (
                                      <span className="whitespace-normal break-words">
                                        {row?.top_acquistion?.map((company, i) => (
                                          <CustomNavigation
                                            key={company?.company_id}
                                            module="company"
                                            mainModule="ma"
                                            name={company.target_company + (i === row?.top_acquistion?.length - 1 ? "" : ", ")}
                                            entityId={company?.company_id}
                                          />
                                        ))}
                                      </span>
                                    ) : (
                                      "--"
                                    )
                                  }
                                />
                              </td>

                              <td className="w-[10%] py-3 px-5 font-medium font-sans_book_body whitespace-normal break-words">
                                <TwolineOverflowToolTip
                                  className="w-[10rem] lg:max-w-[18rem] line-clamp-2 leading-relaxed"
                                  component={
                                    <Link
                                      rel="noopener noreferrer"
                                      className="flex text-start lg:inline whitespace-normal break-words hover:text-[#BC8B20]"
                                      to={routeNames.maCompanyById(row?.last_acquirer)}
                                    >
                                      {row.last_acquired ? row.last_acquired : "--"}
                                    </Link>
                                  }
                                />
                              </td>

                              <td className=" w-[4%] min-w-[140px] py-3 font-sans_book_body text-right pr-[2.8rem]  xl:pr-[3rem] 2xl:pr-[3.5rem]">
                                <p>{row.total_acquistions != 0.00 ? addCommasToNumber(row.total_acquistions) : "--"}</p>
                              </td>
                              <td className={groupId?.myList?.length >0 ?"w-[5%] px-5 py-3 font-sans_book_body pl-1":"w-[5%] px-5 py-3 font-sans_book_body " }>
                              {groupId?.myList?.length >0 ? 
                                 <DeleteItemsFromGroup id={row.company_id} group_id={row?.grp_lt_item_id} type_id={Constants.moduleIds.acquirer_id} setReload={setReload}/>
                                 :<AddNotePopover className="" key={row.acquirer_id} companyId={row.acquirer_id} companyName={row.acquirer_name} type_id={Constants.moduleIds.acquirer_id} sub_type_master_id={sub_type_master_id}/>

                        }</td>
                            </tr>
                          )
                        })
                        : <center><div className="h-[4rem] text-[12pt] lg:text-[15px] text-[15px] text-[#333333] relative mt-[3rem] left-[30rem]">No data found</div></center>
                      }
                    </tbody>
                    : <></>
                  : <></>
                }
              </table>

              {!isLoad ?
                count > 0 ?
                  <></>
                  : <div className='pr-2'>
                  <div className='w-full h-[17rem] bg-white flex items-center justify-center fixed md:relative'>
                    <NoDataPlaceholder />
                  </div>
                  </div>
                :
                <div className='w-full h-[17rem] bg-white flex items-center justify-center absolute md:relative'>
                  <Loader />
                </div>
              }
            </div>
          </div>
        </div>
      </div>

      {data?.num_acquirers && rows.length > 0 ? (
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={data?.num_acquirers}
          pageSize={20}
          onPageChange={(page) => findActivePage(page)}
          allDataRoute={`${location?.pathname}/all`}
          refineSearchFilters={refineSearchFilters}
          monthPickerValue={monthPickerValue}
        />

      ) : (
        ""
      )}
    </>
  )
}

export default Table
